function updateSwatchShape() {
  const swatchStyle = document.body.getAttribute('data-global-swatch-style');
  const colorSwatches = document.querySelectorAll('label.color-swatch');

  colorSwatches.forEach((label) => {
    label.classList.remove('square', 'round', 'square-round-corners');

    if (swatchStyle === "square") {
      label.classList.add('square');
    } else if (swatchStyle === "round") {
      label.classList.add('round');
    } else if (swatchStyle === "square-round-corners") {
      label.classList.add('square-round-corners');
    }
  });
}

document.addEventListener("DOMContentLoaded", updateSwatchShape);
document.addEventListener("shopify:section:load", updateSwatchShape);
document.addEventListener("shopify:section:reorder", updateSwatchShape);
